import {
    StyleSheet
} from "react-native";
import type {
    BreadcrumbItemDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    },
    last: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: BreadcrumbItemDynamicStyleType) => {
    return {
        container: {
            gap: spaces.spacingSm
        }
    };
};
export default stylesheet;
